import { useTranslation } from 'react-i18next';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { useAnalytics } from 'support/helpers/analytics/analytics';
import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';
import { AnnotationNavigationActions } from 'components/WebEDI/AnnotationNavigationActions/AnnotationNavigationActions';

import { AnnotationsLabel } from '../components/AnnotationsLabel';

type Props = {
  warnings: number;
};

export const WarningPreset = ({ warnings }: Props) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const totalCycleableItems = service.useNumberOfCycleableItems();

  const moveToNext = () => {
    track('webedi:next_warning', { nextWarning: service.getCurrentItem() });
    service.moveToNextItem();
  };
  const moveToPrevious = () => {
    track('webedi:previous_warning', { previousWarning: service.getPreviousItem() });
    service.moveToPreviousItem();
  };

  return (
    <Alert withoutIcon severity="warning" fullWidth className="max-h-72 overflow-y-auto">
      <div className="flex w-full items-center justify-between">
        <AlertSection severity="warning" title={t('webedi:viewDocument.warningBanner.title', { count: warnings })}>
          {t('webedi:viewDocument.warningBanner.description')}
        </AlertSection>
        <AnnotationNavigationActions
          leadingContent={
            <AnnotationsLabel
              variant="warning"
              label={t('webedi:viewDocument.errorBanner.warningCount', { count: warnings })}
            />
          }
          totalNumberOfAnnotations={totalCycleableItems}
          onPrev={moveToPrevious}
          onNext={moveToNext}
          prevAnalyticsId="webedi:previous_warning"
          nextAnalyticsId="webedi:next_warning"
          onFocus={service.resetFocus}
          focusAnalyticsId="webedi:warnings_focus_first"
          focusLabel={t('webedi:viewDocument.warningBanner.focusOnWarning')}
        />
      </div>
    </Alert>
  );
};
